import { ConfigProvider, Spin } from 'antd';

import { TableWrapper } from '../../../../components/index';
import { Stopover as StopoverType } from '../../../../types';
import { ReportsTable } from '../styles';
import { OmissionReportTableColumns } from './omissionReportTableColumns';

type OmissionReportTableProps = {
  dataSource?: Array<StopoverType>;
  totalItems?: number;
  isLoadingOmissionReportData?: boolean;
  onChangePagination: (page: number) => void;
  queryPage?: number;
  pageSize?: number;
  onShowSizeChange: (pageSize: number) => void;
};
export function OmissionReportTable(props: OmissionReportTableProps) {
  const {
    dataSource,
    totalItems,
    isLoadingOmissionReportData,
    onChangePagination,
    queryPage,
    pageSize,
    onShowSizeChange,
  } = props;

  function customizeRenderEmpty() {
    return <>Não há escalas omitidas no período.</>;
  }

  return (
    <Spin spinning={isLoadingOmissionReportData} tip="Carregando...">
      <TableWrapper>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <ReportsTable
            rowKey="key"
            pagination={{
              position: ['bottomCenter'],
              pageSize,
              total: totalItems,
              showSizeChanger: true,
              onChange: (page) => onChangePagination(page),
              current: queryPage,
              onShowSizeChange: (_current, size) => onShowSizeChange(size),
            }}
            columns={OmissionReportTableColumns()}
            dataSource={dataSource}
            scroll={{ y: '60vh', scrollToFirstRowOnChange: false }}
            loading={isLoadingOmissionReportData}
          />
        </ConfigProvider>
      </TableWrapper>
    </Spin>
  );
}
